import { render, staticRenderFns } from "./AllCollectionTaskJz.vue?vue&type=template&id=6b344e08&scoped=true&"
import script from "./AllCollectionTaskJz.vue?vue&type=script&lang=js&"
export * from "./AllCollectionTaskJz.vue?vue&type=script&lang=js&"
import style0 from "./AllCollectionTaskJz.vue?vue&type=style&index=0&id=6b344e08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b344e08",
  null
  
)

export default component.exports